export default function initImageCaptions() {
	document.querySelectorAll('[data-image-caption], .image-caption').forEach((block) => {
		const toggle = block.querySelector('.image-caption__toggle');
		const panel = block.querySelector('.image-caption__panel');
		const close = block.querySelector('.image-caption__close');

		if (!toggle || !panel || !close) return;

		const setOpen = (open) => {
			toggle.setAttribute('aria-expanded', String(open));
			panel.hidden = !open;
			if (open) close.focus();
		};

		toggle.addEventListener('click', (event) => {
			event.stopPropagation();
			setOpen(true);
		});
		close.addEventListener('click', (event) => {
			event.stopPropagation();
			setOpen(false);
			toggle.focus();
		});
	});
}
